import React, { useContext } from 'react';
import { DonutChart } from '@trp-beacon-ui-kit/react-visualizations';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { distributeRemainder } from '../../core/util';
import styles from './style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

/* eslint-disable complexity */
const AllocationChartAndLegend = ({
  fund,
  stocks,
  bonds,
  shortTerm,
  small,
  openQuickViewFund,
  setOpenQuickViewFund,
  RDFData,
  isMoneyMarketView,
  fundAllocationsPresent = true
}) => {
  const { next } = useContext(FlowContext);
  const [roundedStocks, roundedBonds, roundedShortTerm] = distributeRemainder(
    [stocks, bonds, shortTerm],
    100
  );
  return (
    <div className="donut-with-legend">
      {fundAllocationsPresent && (
        <>
          <div className="donut">
            {/** @TODO charts should automatically scale to their containers * */}
            <DonutChart
              width={small ? 100 : 175}
              height={small ? 100 : 175}
              ringWidth={small ? 15 : 30}
              colors={['#054c70', '#e17a17', '#7d9845']}
              data={[
                { label: 'Stocks', value: roundedStocks },
                { label: 'Bonds', value: roundedBonds },
                { label: 'Short-term', value: roundedShortTerm }
              ]}
            />
          </div>

          <div className="legend">
            <div className="legend-row">
              <span className="stat-desc">
                <span className="icon stocks-icon" />
                Stocks
              </span>
              <span className="percentages">{roundedStocks}%</span>
            </div>
            <div className="legend-row">
              <span className="stat-desc">
                <span className="icon bonds-icon" />
                Bonds
              </span>
              <span className="percentages">{roundedBonds}%</span>
            </div>
            <div className="legend-row">
              <div className="stat-desc">
                <span className="icon short-term-icon" />
                Short-term
              </div>
              <div className="percentages">{roundedShortTerm}%</div>
            </div>
          </div>
        </>
      )}

      {RDFData ? (
        <div className="button-container">
          <MFBeaconButton
            id="viewFundOverviewBtn"
            data-name={generateGeneralTestID('BYOP', 'ViewFundOverviewButton')}
            type="button"
            onClick={() => setOpenQuickViewFund(!openQuickViewFund)}
            variant="tertiary"
            label="See fund overview"
          />
          <MFBeaconButton
            id="selectFundBtn"
            onClick={next({
              investmentMethod: 'RDF',
              fund
            })}
            variant="primary"
            label="Select fund"
            data-name={generateGeneralTestID('BYOP', 'SelectFundButton')}
          />
        </div>
      ) : (
        isMoneyMarketView && (
          <div className="button-container">
            <MFBeaconButton
              id="viewMoneyMarketFundOverview"
              data-name={generateGeneralTestID(
                'BYOP',
                'ViewMoneyMarketFundOverview'
              )}
              type="button"
              onClick={() => setOpenQuickViewFund(!openQuickViewFund)}
              variant="tertiary"
              label="See fund overview"
            />
            <MFBeaconButton
              id="addThisFund"
              data-name={generateGeneralTestID('BYOP', 'AddFundButton')}
              onClick={next({
                investmentMethod: 'BYOP',
                fund
              })}
              variant="primary"
              label="Add this Fund"
            />
          </div>
        )
      )}
      <style jsx>{styles}</style>
    </div>
  );
};
/* eslint-enable complexity */

export default AllocationChartAndLegend;
